<template>
  <RouterView />
  <CookieConsent />
  <SpeedInsights/>
  <Analytics />
</template>

<script setup>
import CookieConsent from '@/components/CookieConsent.vue';
import { SpeedInsights } from "@vercel/speed-insights/vue"
import { Analytics } from "@vercel/analytics/vue"

// Check and set dark mode before app mount
// if (!localStorage.getItem('dark_mode')) {
//   localStorage.setItem('dark_mode', 'true');
//   document.documentElement.classList.add('my-app-dark');
// } else {
//   if (localStorage.getItem('dark_mode') === 'true') {
//     document.documentElement.classList.add('my-app-dark');
//   } else {
//     document.documentElement.classList.remove('my-app-dark');
//   }
// }

// Just flip if selected
if (localStorage.getItem('dark_mode') === 'true') {
  document.documentElement.classList.add('my-app-dark');
} else {
  document.documentElement.classList.remove('my-app-dark');
}
</script>